import type { GenericReducer } from '@/types/helpers'
import type { UserState } from '@/types/state'
import * as StorageUtils from '@/utils/storage'
import { UserActions, type UserActionsType } from './actions'
import initialState from './initialState'

const fetchReducer: GenericReducer<UserState, UserActionsType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case UserActions.SET_PERMISSIONS: {
      return {
        ...state,
        permissions: action.payload,
      }
    }

    case UserActions.SET_STORAGE_LIMITS: {
      return {
        ...state,
        storageLimits: action.payload,
      }
    }

    case UserActions.INCREASE_STORAGE_LIMITS: {
      const storageLimits = StorageUtils.increaseStorageLimits(
        state.storageLimits,
        action.payload
      )

      return {
        ...state,
        storageLimits,
      }
    }

    case UserActions.DECREASE_STORAGE_LIMITS: {
      const storageLimits = StorageUtils.decreaseStorageLimits(
        state.storageLimits,
        action.payload
      )

      return {
        ...state,
        storageLimits,
      }
    }

    default: {
      return state
    }
  }
}

export default fetchReducer
